import type { Epic } from 'epics/rxjs';
import { isSearchEnhancementsMilestone1Enabled } from 'feature-flags';
import type { SearchAction, ShowSearchAction, UpdateSearchAction } from 'state/actions/search';
import { SEARCH, SHOW_SEARCH, UPDATE_SEARCH } from 'state/actions/search';
import * as qs from '@atlassian/help-center-common-util/history-qs';
import { context as fromLocationContextKey } from '../from-location';

type SearchActions = SearchAction | ShowSearchAction | UpdateSearchAction;

const isValidSearchAction = (action: SearchActions) =>
    (action.type === SHOW_SEARCH || action.type === SEARCH || action.type === UPDATE_SEARCH) &&
    action.payload.context !== fromLocationContextKey;

const setSearchQueryParams = (term?: string, time?: number | null, replaceRoute: boolean = false) => {
    qs.set(
        {
            q: term,
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            q_time: term && !isSearchEnhancementsMilestone1Enabled() ? `${time}` : undefined,
        },
        replaceRoute
    );
};

const epic: Epic<SearchActions> = (action$, store) => {
    return action$
        .filter(isValidSearchAction)
        .do((action) => {
            if ((action.type === SEARCH || action.type === UPDATE_SEARCH) && action.payload.show) {
                const shouldReplaceRoute = qs.get('q') !== undefined;
                setSearchQueryParams(action.payload.term, action.payload.time, shouldReplaceRoute);
                return;
            }

            if (action.type === SHOW_SEARCH) {
                if (action.payload.show) {
                    const state = store.getState();

                    if (state.ui.search.term) {
                        setSearchQueryParams(state.ui.search.term, state.ui.search.time);
                        return;
                    }

                    setSearchQueryParams('');
                    return;
                }

                setSearchQueryParams(undefined);
            }
        })
        .ignoreElements();
};

export default epic;
